import { Oval } from "react-loader-spinner"
import { useSelector } from "react-redux";

const LoadingSpinner = () => {
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  return (
    <div className="loaddingSpinner">
      {/* <FidgetSpinner
        visible={true}
        height="80"
        width="80"
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
        ballColors={['#ff0000', '#00ff00', 'var(--primary-color)0ff']}
        backgroundColor="#F4442E"
      /> */}
      <img
        src={settingsRes?.data?.logo || '/logo.png'}
        alt="Loading..."
        className="pulsing-logo"
        style={{ width: '180px', height: 'auto', objectFit: 'contain' }}
      />
    </div>
  )

}

export default LoadingSpinner